export const SEARCH_HEADER_HEIGHT = 80
export const FOOTER_HEIGHT = 50
